module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/clan-points-icon.f1b105fa.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/clan-points-icon.png
// module id = 2955
// module chunks = 11